import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGiftCardGroupQuery = createQueryHook(GiftCardsApiClient.getGiftCardGroup, {
  queryKey: ['giftCardGroup'],
})
